
angular.module('gallery').directive('trackIt', function () {
	return {
		restrict: 'A',
		require: '^trackable',
		link: function (scope, elem, attr, trackCtrl) {
			trackCtrl.addMark(elem);
		}
	};
});


